module.exports = __webpack_public_path__ + "img/error.1d2c0dbe.png";